import { useContext } from 'react'

import { Screen } from '../../../../../context'
import { useKeyboard } from '../../../../../hooks'
import {
  PREVIEW_VIEW_TYPE_MIN_SCREEN_WIDTH,
  useMultipleViewTypeList,
} from '../../../../MultipleViewTypeList'
import { getViewingProfileLink } from '../../../../RentalPortalViewing'

export function useRentalPortalViewingsMultipleViewTypeList({
  handleReload,
  handleSetPreview,
  handleSetView,
  handleUpdateConfig,
  items,
  listViewType,
  preview,
}) {
  const { width } = useContext(Screen)

  const multipleViewTypeList = useMultipleViewTypeList({
    getProfileLink: getViewingProfileLink,
    handleReload,
    handleSetPreview,
    handleSetView,
    handleUpdateConfig,
    items,
    listViewType,
    preview,
  })

  function handleEscape() {
    multipleViewTypeList.handleResetViewTypeToPlainBody()
  }

  useKeyboard(null, handleEscape)

  return {
    ...multipleViewTypeList,
    isSplitAvailable: width >= PREVIEW_VIEW_TYPE_MIN_SCREEN_WIDTH,
  }
}
